// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__GUMBS","modalFooterButton":"ModalNotes_modalFooterButton__NZwpy"};